import React, { useState, useRef, useEffect } from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';

import './styles.css'

const AlertCustom = ({
    showAlert,
    setShowAlert,
    values,
    alert,
    loadingShow,
    loadingOverwrite
}) => {
    // const [num, setNum] = useState(10);

    // let intervalRef = useRef();

    // const decreaseNum = () => setNum((prev) => prev - 1);

    // useEffect(() => {
    //     intervalRef.current = setInterval(decreaseNum, 1000)
    // }, [showAlert])

    return (
        <div>
            {showAlert ? 
                <Alert className="alert-custom" variant={alert.type} onClose={() => setShowAlert(false)} dismissible>
                    <Alert.Heading>{alert.header}</Alert.Heading>
                    <p>
                        {alert.message}
                    </p>

                    {alert.options_btn.length > 0 ?
                        <div className="d-flex justify-content-end">
                            {alert.options_btn.map((item, index) => (
                                item.option_loading === "first" ? 
                                    <Button
                                        className="btn-loader-135px"
                                        variant={item.variant}
                                        type="submit"
                                        onClick={() => item.onHandleClick(values)}
                                        disabled={loadingOverwrite}
                                    >
                                        {loadingOverwrite && (
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                        )}
                                        {loadingOverwrite && <span>{"  loading..."}</span>}
                                        {!loadingOverwrite && <span>{item.title}</span>}
                                    </Button>
                                    :
                                    <Button
                                        className="btn-loader-135px"
                                        variant={item.variant}
                                        type="submit"
                                        onClick={() => item.onHandleClick()}
                                        disabled={loadingShow}
                                    >
                                        {loadingShow && (
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                        )}
                                        {loadingShow && <span>{"  loading..."}</span>}
                                        {!loadingShow && <span>{item.title}</span>}
                                    </Button>
                            ))}
                        </div>
                    : null}
                </Alert>
            : null}
        </div>
    );
}

export default AlertCustom;
